import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';
import Component from 'flarum/common/Component';
import Discussion from 'flarum/common/models/Discussion';
import DiscussionPage from 'flarum/forum/components/DiscussionPage';
export class ApplicationReviewPanel extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.data = null;
    this.busy = false;
    this.failed = false;
    this.text = '';
    this.page = 1;
    this.draftKey = 'hideout:review:' + (app.session.user?.id() || 'guest') + ':' + this.attrs.discussion.id();
    try {
      this.text = sessionStorage.getItem(this.draftKey) || '';
    } catch {}
    this.load();
  }
  url() {
    return app.forum.attribute('apiUrl') + '/hideout/applications/' + this.attrs.discussion.id() + '/reviews';
  }
  load() {
    this.failed = false;
    app.request({
      method: 'GET',
      url: this.url() + '?page=' + this.page
    }).then(data => {
      this.data = data;
    }).catch(() => {
      this.failed = true;
    }).finally(() => m.redraw());
  }
  submit(event) {
    event.preventDefault();
    if (this.busy) return;
    this.busy = true;
    app.request({
      method: 'POST',
      url: this.url(),
      body: {
        content: this.text
      }
    }).then(data => {
      this.data = data;
      this.page = 1;
      this.text = '';
      sessionStorage.removeItem(this.draftKey);
      this.attrs.discussion.pushData({
        attributes: {
          hideoutReviewCount: data.count
        }
      });
      app.alerts.show({
        type: 'success'
      }, 'Review submitted. Only managers and above can read it.');
    }).finally(() => {
      this.busy = false;
      m.redraw();
    }).catch(() => {});
  }
  view() {
    const data = this.data;
    return m('section.HideoutApplicationReviews', {
      'aria-label': 'Application reviews'
    }, m('h2', 'Application reviews' + (data ? ' · ' + data.count + ' ' + (data.count === 1 ? 'reply' : 'replies') : '')), m('p', 'Members and staff can leave a review. Review text is visible only to managers and above.'), this.failed ? m('button.Button', {
      onclick: () => this.load()
    }, 'Retry loading reviews') : !data ? m('p', {
      'role': 'status'
    }, 'Loading reviews…') : null, data?.canRead && m('div.HideoutReviewList', (data.reviews || []).map(review => m('article.HideoutReview', {
      key: review.id
    }, m('h3', review.username || 'Former member'), m('time', review.created_at), m('p.HideoutReviewText', review.content))), data.count === 0 && m('p', 'No reviews yet.'), data.count > 30 && m('div.HideoutReviewPagination', m('button.Button', {
      disabled: this.page === 1,
      onclick: () => {
        this.page--;
        this.load();
      }
    }, 'Previous'), m('span', 'Page ' + this.page), m('button.Button', {
      disabled: this.page * 30 >= data.count,
      onclick: () => {
        this.page++;
        this.load();
      }
    }, 'Next'))), data?.canReview ? m('form', {
      onsubmit: event => this.submit(event)
    }, m('label', {
      for: 'hideout-review-text'
    }, 'Your review'), m('textarea.FormControl', {
      id: 'hideout-review-text',
      required: true,
      minlength: 5,
      maxlength: 3000,
      rows: 5,
      value: this.text,
      oninput: event => {
        this.text = event.target.value;
        try {
          sessionStorage.setItem(this.draftKey, this.text);
        } catch {}
      }
    }), m('p.HideoutReviewPrivacy', 'Your review will not be shown to the applicant or other members.'), m('button.Button.Button--primary', {
      type: 'submit',
      disabled: this.busy
    }, this.busy ? 'Sending…' : 'Submit private review')) : data && !app.session.user && m('p', 'Sign in to leave a review.'));
  }
}
export default function applications() {
  // Resolve after all extension bundles load; no dependency on their script evaluation order.
  const TagHero = flarum.reg.get('flarum-tags', 'forum/components/TagHero');
  override(Discussion.prototype, 'replyCount', function (original) {
    return this.attribute('hideoutApplication') ? this.attribute('hideoutReviewCount') || 0 : original();
  });
  extend(DiscussionPage.prototype, 'view', function (vnode) {
    if (this.discussion?.attribute('hideoutApplication') && !this.loading && vnode) {
      // Core stream siblings are unkeyed. Keep the remount key inside its own unkeyed wrapper.
      vnode.children = [...(vnode.children || []), m('div.HideoutApplicationReviewMount', m(ApplicationReviewPanel, {
        key: this.discussion.id(),
        discussion: this.discussion
      }))];
    }
  });
  extend(TagHero.prototype, 'contentItems', function (items) {
    if (this.attrs.model.slug() === 'admin-applications') items.add('hideout-apply', m('a.Button.Button--primary', {
      href: 'https://thehideoutcommunity.com/applications'
    }, 'Apply for Surf or GMod admin'), 50);
  });
  // Core TagHero styles the outer hero via --hero-bg. Apply category image/color there too.
  override(TagHero.prototype, 'style', function (original) {
    const tag = this.attrs.model;
    const image = tag.attribute('hideoutBannerImage');
    const color = tag.attribute('hideoutBannerColor') || '#101317';
    return {
      ...original(),
      '--hero-bg': color,
      backgroundColor: color,
      backgroundImage: image ? 'linear-gradient(rgba(11,12,14,.72),rgba(11,12,14,.72)),url("' + encodeURI(image).replaceAll('"', '%22').replaceAll('\\', '%5C') + '")' : 'linear-gradient(rgba(11,12,14,.72),rgba(11,12,14,.72)),radial-gradient(ellipse at 50% 20%,rgba(78,167,255,.16),transparent 70%)',
      backgroundSize: 'cover',
      backgroundPosition: 'center'
    };
  });
}